module.exports = __webpack_public_path__ + "static/onion_w-1d90124d0aeba5ee42a099d54c7471d9.png";